import { DictationWordTypeEnum } from '@doltech/utils/lib/constants';
import { uniq } from 'lodash';
import { types } from 'mobx-state-tree';
import { DictationWord } from './word.store';
import { SpeechCorrectionModel } from '@doltech/ui/lib/voice-recognition/models/speech-correction-model';
import { FileInfo } from '../../question-data-model/Script/abtract-script.store';

export const PopularWordLearnHistory = types.model('PopularWordLearnHistory', {
  type: types.maybeNull(types.string),
  key: types.maybeNull(types.string),
  correctPercentage: types.maybeNull(types.number),
  marked: types.maybeNull(types.string),
  userAnswer: types.array(types.string),
  speech: types.maybeNull(FileInfo),
  speechCorrections: types.optional(types.array(SpeechCorrectionModel), []),
});

const PopularWordsModel = types.model('PopularWordsModel', {
  key: types.maybeNull(types.string),
  enWord: types.maybeNull(types.string),
  viWord: types.maybeNull(types.string),
  pronunciation: types.maybeNull(types.string),
  isLearnedPopularWordPronun: types.maybeNull(types.boolean),
  learnedHistory: types.maybeNull(PopularWordLearnHistory),
});

export const DictationSentence = types
  .model('DictationSentence', {
    key: types.number,
    start: types.number,
    end: types.number,
    content: types.string,
    contentVi: types.maybeNull(types.string),
    words: types.array(DictationWord),
    character: types.maybeNull(types.string),
    popularWords: types.array(PopularWordsModel),
    dualToggle: types.maybeNull(types.string),
  })
  .actions((self) => {
    return {
      setPopularWords(popularWords) {
        self.popularWords = popularWords;
      },
    };
  })
  .views((self) => {
    return {
      get blankWordList() {
        return self.words
          .filter((i) => i.type === DictationWordTypeEnum.BLANK)
          .map((v) => v.value.toLowerCase());
      },
    };
  })
  .views((self) => {
    return {
      get isCurrentSentenceValid() {
        if (uniq(self.blankWordList).length < self.blankWordList.length) {
          return false;
        }
        return true;
      },
      get duplicatedWords() {
        const countWord = {};
        const duplicatedWordList = [];
        self.blankWordList.forEach((w) => {
          countWord[w] = (countWord[w] || 0) + 1;
        });
        for (const [word, duplicateCount] of Object.entries(countWord)) {
          if ((duplicateCount as number) >= 2) {
            duplicatedWordList.push({ word, duplicateCount });
          }
        }
        return duplicatedWordList;
      },
    };
  });
